interface ISiteElementButtonConfig {
    title: string;
    icon: string;
}

class SiteElementFilterClear
    extends QueryElement<HTMLElement> {
    
    constructor(element: HTMLElement, site: SiteAssortment) {
        super(element);
        
        var button = new SiteElementButton({
            title: "",
            icon: "clear"
        });
        button.on("click", () => {
            site.clearFilterModel();
            site.updateFilterModel(null, []);
        });
        
        this.append(button);
    }
    
}